export const breakpoints = {
  lg: 64, // rem
  xl: 80, // rem
  '2xl': 96, // rem
}
